import { render, staticRenderFns } from "./EditImportComponent.vue?vue&type=template&id=2320f630"
import script from "./EditImportComponent.vue?vue&type=script&lang=js"
export * from "./EditImportComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports